import { useEffect } from "react";

const DEFAULT_TITLE = "Abhinav Dhiman · The Digital Marketer";

export default function useSeo(title, description) {
  useEffect(() => {
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta ? meta.getAttribute("content") : null;
    document.title = title;
    if (meta && description) meta.setAttribute("content", description);
    return () => {
      document.title = DEFAULT_TITLE;
      if (meta && prevDesc) meta.setAttribute("content", prevDesc);
    };
  }, [title, description]);
}
